import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=6c896738&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"
import style0 from "./table-list.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./table-list.vue?vue&type=style&index=1&id=6c896738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c896738",
  null
  
)

export default component.exports